import { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import Dropdowns from "./components/Dropdowns";
import Metrics from "./components/Metrics";
import Charts from "./components/Charts";
import Leaderboard from "./components/Leaderboard";
import LoadingOverlay from "./components/LoadingOverlay";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { apiBaseUrl, fetchElectionResults, fetchEvents } from "./services/api";

import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import LongPoolHook from "./LongPoolHook";



// const apiBaseUrl = "http://20.164.36.185:4000";
//const apiBaseUrl = 'http://localhost:5110';

export default function () {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [results, setResults] = useState(null);
  const [change, setChange] = useState(true);
  const [delimitation, setDelimitation] = useState(null);
  var connectionRef = useRef(null)

  LongPoolHook(10000, async () => {
    if (selectedEvent && delimitation) {
      console.log(selectedEvent)

      var res = await fetchElectionResults(selectedEvent, delimitation.delimitationLevelID, delimitation.delimitationID)
      setResults(res);

    }
  })

  useEffect(() => {

    async function loadEvents() {
      setLoading(true);
      try {
        const data = await fetchEvents();
        setEvents(data || []);
        if (data && data.length > 0) {
          setSelectedEvent(data[0].eventID);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load events");
      } finally {
        setLoading(false);
      }
    }
    loadEvents();
  }, []);






  // 1. Create the connection ONCE (mount/unmount only)
  useEffect(() => {
    if (connectionRef.current === null) {
      // const connection = new HubConnectionBuilder()
      //   .withUrl(`${apiBaseUrl}/resultshub`)
      //   .withAutomaticReconnect()
      //   .configureLogging(LogLevel.Information)
      //   .build();

      // connection
      //   .start()
      //   .then(() => console.log("SignalR connected"))
      //   .catch((err) => console.error("SignalR start failed:", err));

      // connectionRef.current = connection;
    }

    // cleanup only when component unmounts
    return () => {
      if (connectionRef.current) {
        connectionRef.current.stop().catch(() => { });
        connectionRef.current = null;
      }
    };
  }, []);


  // // 2. Manage the handler separately
  // useEffect(() => {
  //   if (connectionRef.current) {
  //     // remove old handler to avoid duplicate listeners
  //     connectionRef.current.off("UpdateDashboard");

  //     // register new handler
  //     connectionRef.current.on(
  //       "UpdateDashboard",
  //       (eventID, delimitationLevelID, delimitationID, newData) => {
  //         if (eventID === selectedEvent) {
  //           setResults(newData);
  //         }
  //       }
  //     );
  //   }
  //   return () => {
  //     if (connectionRef.current) {
  //       connectionRef.current.off("UpdateDashboard");

  //     }
  //   };
  // }, [selectedEvent, change, connectionRef]); // 👈 only re-run when selectedEvent changes



  useEffect(() => {

  }, []);

  useEffect(() => {
    setResults(null);
  }, [selectedEvent]);



  return (
      <>
        {loading && <LoadingOverlay />}
        <main className="card">
          <Dropdowns
            events={events}
            selectedEvent={selectedEvent}
            onSelectEvent={setSelectedEvent}
            onResults={setResults}
            stateChange={(res) => setChange(res)}
          />

          {selectedEvent !== null && <LocalDelimitationNational
            showFilter={false}
            // onFilter={async ({ delimitationID, delimitationLevelID }) => {
            //   console.log(delimitationID, delimitationLevelID)
            //   setLoading(true)
            //   var res = await fetchElectionResults(selectedEvent, delimitationLevelID, delimitationID)
            //   setResults(res);
            //   setLoading(false)

            // }}
            onChange={async (delimitationID, delimitationLevelID) => {
              console.log(delimitationID, delimitationLevelID)
              setDelimitation({ delimitationLevelID, delimitationID })
              setLoading(true)
              var res = await fetchElectionResults(selectedEvent, delimitationLevelID, delimitationID)
              setResults(res);
              setLoading(false)
            }}
            onClearFilter={() => {
              setResults(null)
              setDelimitation(null)
            }
            }
            key={selectedEvent} bold={false} isNational={true} />}

          {results && <Metrics data={results} />}
          {results &&  <Charts data={results} />}
          {results && <Leaderboard candidates={results.candidateResults} />}
          {error && <div className="text-red-500 text-center p-4">{error}</div>}
        </main>
      </>

  );
}

